import { RobotConfusedOutlineIcon } from './RobotConfusedOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 8361794A-9B3E-44CA-9AA4-EA842227D7C2
 * name robot-confused-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-confused-outline.svg
 * tags
 */
export const EmojiRobotConfusedOutlineIcon = RobotConfusedOutlineIcon;
export default EmojiRobotConfusedOutlineIcon